var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburgerX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.24,196.52c-2.44,0-4.73-0.95-6.45-2.67c-1.72-1.72-2.67-4.02-2.67-6.45c0-2.44,0.95-4.73,2.67-6.46 L180.67,5.04c1.72-1.72,4.02-2.67,6.45-2.67s4.73,0.95,6.45,2.67c1.72,1.72,2.67,4.02,2.67,6.45c0,2.44-0.95,4.73-2.67,6.45 L17.69,193.84C15.97,195.57,13.67,196.52,11.24,196.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.5,7.87L7.61,183.76c-2,2-2,5.25,0,7.25h0c2,2,5.25,2,7.25,0L190.75,15.12c2-2,2-5.25,0-7.25l0,0 C188.75,5.87,185.5,5.87,183.5,7.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.39,196.94c-2.44,0-4.73-0.95-6.45-2.67L5.05,18.38c-1.72-1.72-2.67-4.02-2.67-6.45 c0-2.44,0.95-4.73,2.67-6.45C6.77,3.75,9.06,2.8,11.5,2.8c2.44,0,4.73,0.95,6.45,2.67l175.89,175.89c3.56,3.56,3.56,9.35,0,12.91 C192.12,195.99,189.83,196.94,187.39,196.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.13,8.3l175.89,175.89c2,2,2,5.25,0,7.25h0c-2,2-5.25,2-7.25,0L7.88,15.55c-2-2-2-5.25,0-7.25l0,0 C9.88,6.3,13.12,6.3,15.13,8.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerX);
export default __webpack_public_path__ + "static/media/hamburgerX.3cfa533a313090c2f314e4fdfaf6c4c1.svg";
export { ForwardRef as ReactComponent };